var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosePrimaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.507 6.34316C16.9798 5.81595 16.125 5.81595 15.5978 6.34316L11.8501 10.0908L8.10245 6.34316C7.57524 5.81595 6.72047 5.81595 6.19326 6.34316C5.66605 6.87037 5.66605 7.72514 6.19326 8.25235L9.94092 12L6.19326 15.7477C5.66605 16.2749 5.66605 17.1297 6.19326 17.6569C6.72047 18.1841 7.57524 18.1841 8.10245 17.6569L11.8501 13.9092L15.5978 17.6569C16.125 18.1841 16.9798 18.1841 17.507 17.6569C18.0342 17.1297 18.0342 16.2749 17.507 15.7477L13.7593 12L17.507 8.25235C18.0342 7.72514 18.0342 6.87037 17.507 6.34316Z",
    fill: "#2D6CE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePrimaryIcon);
export default __webpack_public_path__ + "static/media/close-primary-icon.ca1784059813221626e330c0b4addb5a.svg";
export { ForwardRef as ReactComponent };